(function () {
  const STORAGE_KEY = 'recently_viewed_products_v1';

  function normalizeHandle(value) {
    return String(value || '')
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function getExcludedProductHandles() {
    const handles = window.__mfExcludedProductHandles__;
    if (!Array.isArray(handles)) return [];
    return handles.map((handle) => normalizeHandle(handle)).filter(Boolean);
  }

  function getProductHandleFromUrl(url) {
    if (!url) return '';

    try {
      const parsedUrl = new URL(url, window.location.origin);
      const segments = parsedUrl.pathname.split('/').filter(Boolean);
      return normalizeHandle(segments[segments.length - 1] || '');
    } catch (error) {
      return normalizeHandle(url.split('/').filter(Boolean).pop() || '');
    }
  }

  function isExcludedProduct(product) {
    const productHandle = getProductHandleFromUrl(product?.url);
    if (!productHandle) return false;
    return getExcludedProductHandles().includes(productHandle);
  }

  function safeParse(json) {
    if (!json) return [];
    try {
      const parsed = JSON.parse(json);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function saveRecentlyViewed(product) {
    if (!product || !product.id) return;
    if (isExcludedProduct(product)) return;

    try {
      const raw = window.localStorage.getItem(STORAGE_KEY);
      const current = safeParse(raw);
      const withoutCurrent = current.filter(
        (p) => String(p.id) !== String(product.id)
      );
      withoutCurrent.unshift(product);
      const trimmed = withoutCurrent.slice(0, 20);
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed));
    } catch (error) {
      // Fail silently if storage is unavailable.
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const node = document.getElementById('recently-viewed-product-data');
    if (!node) return;

    const product = {
      id: node.dataset.productId,
      title: node.dataset.productTitle,
      url: node.dataset.productUrl,
      image: node.dataset.productImage,
      price: node.dataset.productPrice,
    };

    saveRecentlyViewed(product);
  });
})();
